import { useMatches } from "@tanstack/react-router";

/**
 * The match for the page being shown, which is the deepest route matched.
 *
 * `useMatch({ strict: false })` returns the match nearest the calling component
 * instead, so in a layout like the main menu it gives the layout's own route.
 */
export const useCurrentRouteMatch = () => {
  const matches = useMatches();
  return matches[matches.length - 1];
};
